export const emotionQuotes = [
  `화가 자주 치밀고 짜증이 나는 날이라면, 목(木)의 기운이 지나치게 치성해진 상태일 수 있습니다.
방향성이 막혔거나 의욕이 눌린 상태에서 분노로 바뀌는 경우가 많죠.
이럴 땐 걷기나 스트레칭처럼 몸을 움직여 기운의 흐름을 풀어주는 것이 좋습니다.
주변 사람이 이런 상태라면 말로 설득하기보다 잠시 조용히 기다려 주세요.
공간을 주는 것이 오히려 더 깊은 이해로 이어질 수 있습니다.`,

  `마음이 조급하고 들뜬 날은 화(火)의 기운이 과도하게 올라온 상태일 수 있습니다.
생각보다 행동이 앞서거나, 사소한 일에도 쉽게 자극받는 현상이 나타나죠.
이럴 땐 따뜻한 차 한 잔과 깊은 호흡, 차분한 음악이 큰 도움이 됩니다.
만약 상대방이 이런 상태라면 급히 해결하려 들기보다, 말없이 곁을 지키고 따뜻한 존재감을 전해주세요.
그 자체로 큰 위안이 됩니다.`,

  `걱정이 많고 생각이 끊이지 않을 때는 토(土)의 기운이 과도해진 상태일 수 있습니다.
지나친 균형감각과 책임감이 마음을 짓누르게 되는 거죠.
이럴 땐 자연 속에서 땅을 밟으며 깊은 숨을 쉬는 활동이 좋습니다.
주변 사람이 이런 상태라면 조언보다는 경청이 먼저입니다.
그들이 필요로 하는 건 정답이 아니라, '들어주는 사람'일 수 있습니다.`,

  `슬픔이 쉽게 올라오고 사소한 일에도 눈물이 맺히는 날은 금(金)의 기운이 지나치게 활성화된 상태일 수 있습니다.
이 기운은 정리를 상징하기도 하지만, 지나치면 단절과 상실의 감정을 불러오게 되죠.
이럴 땐 억지로 감정을 누르기보다는 조용한 음악을 들으며 감정을 자연스럽게 흘려보내는 것이 좋습니다.
만약 누군가가 이런 상태라면 말보다는 함께 조용히 있어주는 것이 큰 위로가 됩니다.`,

  `불안과 두려움이 커지는 날에는 수(水)의 기운이 지나치게 작용한 상태일 수 있습니다.
수는 깊고 조용한 에너지를 의미하지만, 과하면 침잠하거나 방향을 잃을 수 있죠.
따뜻한 국물 음식이나 햇볕 아래에서의 짧은 산책이 큰 도움이 됩니다.
이런 상태의 사람에게는 논리적인 위로보다는 '너무 걱정하지 마, 내가 옆에 있어' 같은 정서적 지지가 필요합니다.`,

  `감정이 쉽게 들쑥날쑥하고 말과 행동이 따로 노는 날이라면 화(火)의 기운이 불균형해진 상태일 수 있습니다.
마음의 불이 이리저리 튀는 것이죠. 심호흡과 함께 감정을 붙들어주는 루틴이 필요합니다.
상대방이 이렇다면, 에너지를 억누르기보다 자연스럽게 흘러가도록 공간을 마련해 주세요.`,

  `매사에 의욕이 떨어지고 '뭘 해도 재미없다'는 생각이 든다면 토(土)의 기운이 약해진 상태일 수 있습니다.
토는 중심을 잡아주는 기운인데, 약해지면 무기력과 회피로 이어지죠. 간단한 정리 정돈이나 따뜻한 음식이 도움이 됩니다.
이런 상태의 사람에겐 지나친 자극보다, 규칙적인 생활을 함께 만들어주는 것이 효과적입니다.`,

  `질투나 시기심이 올라오는 날은 금(金)의 기운이 뾰족해진 경우일 수 있습니다.
자신과 타인을 비교하게 되는 심리는 내면의 불안을 반영하기도 하죠.
이럴 땐 타인의 시선을 잠시 멈추고, 나의 소중한 점들을 되새겨보는 시간이 필요합니다.
상대방이 이런 상태라면 평가보다 수용의 언어가 우선되어야 합니다.`,

  `자꾸만 멍해지고 정신이 분산된다면 수(水)의 기운이 흩어져 흐름이 약해진 상태일 수 있습니다.
수는 깊이를 주는 기운이지만, 분산되면 중심을 잃기 쉽습니다.
조용한 공간에서 한 가지 일에 몰입하는 시간이 필요합니다.
이럴 땐 상대에게 정보를 주입하기보다 질문을 통해 집중을 유도해보는 게 좋습니다.`,

  `에너지가 넘쳐서 가만히 있기 힘든 날은 화(火)의 기운이 과도하게 활성화된 상태일 수 있습니다.
이 기운은 창의성과 열정을 주지만, 과하면 소모로 이어지죠.
짧은 운동이나 글쓰기처럼 에너지를 건강하게 배출할 방법을 찾아보세요.
주변 사람이 이렇다면, 그 열정을 인정해주되 방향성을 잡아주는 말이 필요합니다.`,

  `자신감이 바닥나고, 내가 쓸모없게 느껴질 때는 금(金)의 기운이 위축된 상태일 수 있습니다.
자기 가치를 부정하게 되면, 타인의 시선에도 예민해지고 말수가 줄어들죠.
이럴 땐 스스로를 칭찬해주는 작은 루틴이 도움이 됩니다.
주변 사람이 이런 상태라면 무심한 듯 전해지는 '너 잘하고 있어'라는 한 마디가 큰 힘이 됩니다.`,

  `너무 많은 선택지 앞에서 결정하지 못하고 머뭇거릴 땐 목(木)의 기운이 혼란스러운 상태일 수 있습니다.
방향성이 흐려지고, 머릿속은 복잡한데 발은 움직이지 않게 되죠.
이럴 땐 우선순위를 딱 하나만 정하고 그 방향으로 가보는 게 좋습니다.
결정이 어려운 사람에겐 기다림보다, ‘하나만 골라볼까?’ 같은 유도형 질문이 도움이 됩니다.`,

  `사소한 일에 민감하게 반응하고 기분이 요동친다면 화(火)의 기운이 불규칙한 상태일 수 있습니다.
작은 자극에도 감정이 폭발하거나 가라앉기 반복되죠.
이럴 땐 정적인 환경에서 혼자 있는 시간을 가지는 것이 좋습니다.
상대방이 이런 상태일 땐 감정을 평가하지 말고, '그럴 수도 있지'라는 공감의 여지를 남겨주세요.`,

  `몸은 멀쩡한데 왠지 마음이 공허하고, 아무 일에도 감흥이 없다면 수(水)의 기운이 고갈된 상태일 수 있습니다.
감정적 깊이를 느끼지 못하는 무감각은 심리적 방어일 수도 있습니다.
이럴 땐 무리한 감정 회복보다 '있는 그대로 쉼'이 먼저입니다.
상대가 이런 상태일 땐 섣불리 다가서기보다, 존재만으로 곁에 있어주는 자세가 중요합니다.`,

  `모든 것을 완벽하게 해내야 할 것 같은 압박감이 들 때는 토(土)의 기운이 과잉된 상태일 수 있습니다.
주위 사람들을 챙기느라 정작 자신을 돌보지 못할 수 있죠.
이럴 땐 '나부터 챙겨야 한다'는 자각이 필요합니다.
이런 사람에게는 '넌 늘 잘하고 있어'보다, '조금은 네 몫도 남겨둬'라는 말이 위로가 됩니다.`,

  `모든 사람과 잘 지내야 한다는 강박이 들 때는 금(金)의 기운이 과도하게 작용하는 경우입니다.
질서를 유지하려는 욕구가 인간관계에 과도하게 적용되면서 피로감이 생기죠.
이럴 땐 관계를 줄이기보다, 경계를 분명히 하는 게 도움이 됩니다.
상대방이 이런 상태일 땐 무조건적 동의보다, 선을 존중해주는 말이 더 편안함을 줍니다.`,

  `무슨 일이든 내가 아니면 안 될 것 같은 책임감에 눌릴 때는 토(土) 기운이 무겁게 작용하는 상태입니다.
이럴 땐 작은 위임부터 연습해보는 게 좋습니다.
‘모두 나에게 달렸다’는 마음이 지나치면 몸과 마음이 모두 지치게 됩니다.
이런 상태의 사람에겐 '그건 내가 해볼게'라는 짧은 제안이 큰 해방감을 줄 수 있습니다.`,

  `계획대로 되지 않는 일에 쉽게 좌절하고 의욕을 잃는다면 목(木)의 기운이 고갈된 상태일 수 있습니다.
계획과 실행 사이의 괴리가 자존감 저하로 이어지기 쉽습니다.
이럴 땐 과정 중 일부만 회복해도 충분하다는 인식 전환이 필요합니다.
주변 사람이 이런 상태라면, '결과보다 꾸준함이 더 중요해'라는 말이 위로가 됩니다.`,

  `혼자 있는 시간이 지나치게 늘어나고, 타인과의 교류가 부담스럽게 느껴질 때는 수(水)의 기운이 과도해진 상태일 수 있습니다.
이 기운이 깊이를 주긴 하지만, 고립을 초래할 수도 있죠.
이럴 땐 가벼운 만남으로 서서히 교류의 회로를 다시 여는 것이 좋습니다.
상대가 이런 상태일 땐 억지로 끌어내지 말고, 편안한 선택지를 제안해 주세요.`,

  `자꾸 남과 비교하면서 뒤처진 느낌이 든다면 금(金)의 기운이 지나치게 날카로워진 상태일 수 있습니다.
비교는 때로 동기부여가 되지만, 지나치면 열등감과 거리감으로 이어집니다.
이럴 땐 자신의 속도를 다시 확인해보는 게 좋습니다.
이런 상태의 사람에겐 '너만의 리듬이 있어'라는 말이 깊이 스며듭니다.`,

  `사소한 일에도 자꾸 마음이 불안정해지고, 평소보다 말수가 많아지는 날은 화(火)의 기운이 위로 솟구친 상태일 수 있습니다.
겉으로는 밝고 활기차 보일 수 있지만, 안에서는 감정이 요동치고 있다는 신호입니다.
이럴 때는 조용한 공간에서 마음을 가라앉히는 호흡 훈련이 도움이 됩니다.
상대방이 이렇다면 겉모습만 보고 오해하지 말고, 잠시 조용히 곁을 지켜주세요.`,

  `해야 할 일이 많은데 손이 안 움직이고, 자꾸만 주변 정리에 집착하게 된다면 토(土)의 기운이 경직된 상태일 수 있습니다.
일의 본질보다 형식에 몰입하게 되는 건 마음이 불안정하다는 반증이기도 하죠.
이럴 땐 큰 그림을 다시 확인하며 우선순위를 재조정하는 것이 좋습니다.
상대가 이렇다면 잔소리보다 “어떤 게 가장 부담돼?”라는 말이 도움이 됩니다.`,

  `자꾸 다른 사람의 반응을 의식하게 되고, 내 말에 대해 불필요한 해석을 반복하게 된다면 금(金)의 기운이 예민해진 상태일 수 있습니다.
내면이 위축되면 판단이 흐려지고, 말 한마디에도 마음이 크게 흔들릴 수 있습니다.
이럴 땐 적당한 거리에서 자신을 보호하는 훈련이 필요합니다.
상대방이 이렇다면 위로보다 “나는 지금 네 편이야”라는 말이 더 큰 안정감을 줍니다.`,

  `자꾸 화가 치밀고, 작은 일에도 짜증이 날 땐 목(木)의 기운이 막힌 상태일 수 있습니다.
목은 나무처럼 위로 뻗고 나아가려는 성향을 가지며, 간(肝)과 연결돼 의욕과 추진력, 계획을 관장합니다.
하지만 이 기운이 막히면 나아가야 할 방향을 찾지 못하고, 감정이 안에서 고이거나 폭발하는 식으로 드러납니다.
이럴 땐 억지로 참고 버티기보다는, 몸을 움직여 기운의 흐름을 풀어주는 것이 중요합니다.
걷기나 스트레칭처럼 간단한 운동만으로도 기운이 순환되며, 감정도 함께 정돈되기 시작하죠.
주변에 이런 상태의 사람이 있다면, 말로 설득하거나 진정시키려 들기보다 그저 잠시 공간을 주는 것이 더 효과적입니다.
목의 분노는 공격성이 아니라, 나아가지 못하는 막힘에서 오는 좌절감일지도 모릅니다.`,

  `마음이 자꾸 들뜨고, 사소한 일에도 과하게 반응할 땐 화(火)의 기운이 지나치게 치성해진 상태일 수 있습니다.
화는 위로 솟는 에너지로, 심장(心)과 연결되어 열정, 기쁨, 판단력, 표현력을 주관합니다.
하지만 이 기운이 과하면 속이 타는 듯한 조급함, 불안정한 말과 행동, 충동적 판단으로 나타납니다.
머리는 복잡한데 마음은 가볍고, 말은 많아지는데 중심은 흐트러지기 쉽죠.
이럴 땐 차분한 음악, 느린 호흡, 따뜻한 차 한 잔처럼 열을 가라앉히는 정적인 자극이 큰 도움이 됩니다.
화의 기운은 무조건 나쁜 것이 아니라, 적절히 타오를 때 빛을 발합니다.
만약 가까운 사람이 이런 상태라면, 설득하려 들기보다 말없이 곁을 지켜주는 따뜻한 존재감이 훨씬 깊이 닿습니다.
과열된 마음은 이성보다 공감과 안정감을 필요로 합니다.`,

  `생각이 많아지고, 해야 할 일은 많은데 손이 잘 안 움직일 때는 토(土)의 기운이 과해진 상태일 수 있습니다.
토는 가운데를 지키는 기운으로 균형감, 책임감, 반복과 안정을 관장하며, 비장(脾)과 연결됩니다.
이 기운이 지나치면 지나치게 신중해지고, 사소한 일에도 마음이 무겁고, 쉽게 피로해집니다.
꼼꼼함이 장점이지만, 한순간엔 그것이 지나친 자기 검열과 책임의 짐으로 작용할 수 있죠.
토의 감정은 겉으로 잘 드러나지 않고 내면에 눌러두는 특징이 있어서, 스스로도 자신의 피로를 잘 인지하지 못할 때가 많습니다.
이럴 땐 자연 속에서 흙을 밟거나 가벼운 산책처럼 대지의 에너지와 연결된 활동이 도움이 됩니다.
주변에 이런 사람이 있다면, 조언이나 방향 제시보다 “너무 애쓰지 않아도 돼”라는 수용적인 말 한마디가 마음의 무게를 덜어줄 수 있습니다.`,

  `유난히 말수가 줄고, 사람들과의 거리감이 느껴지는 날은 금(金)의 기운이 강해진 상태일 수 있습니다.
금은 폐(肺)와 연결되며, 절제, 수렴, 정리의 에너지를 주관합니다.
이 기운이 과하면 감정이 안으로 접히고, 슬픔이나 상실감, 또는 표현되지 못한 감정의 고립으로 나타납니다.
금은 늘 정갈하고 단정하려 하지만, 그 안엔 흐르지 못한 감정의 응어리가 숨겨져 있기도 합니다.
이럴 때는 굳이 마음을 열라고 다그치기보다, 존중을 담은 침묵과 편안한 분위기가 큰 위로가 됩니다.
금의 감정은 폭발이 아닌 내면의 얼어붙음이며, 그 속에는 말 못한 진심이 숨어 있습니다.
가까운 사람이 이런 상태라면, 함께 있어주되 지나치게 간섭하지 않는 거리를 유지하는 것이 가장 따뜻한 배려일 수 있습니다.`,

  `아무것도 하기 싫고, 마음속에 깊은 불안이 깔려 있는 날은 수(水)의 기운이 과하거나 정체된 상태일 수 있습니다.
수는 신장(腎)과 연결되어 있으며, 깊이, 정지, 지혜, 공포와 관련된 에너지를 담고 있습니다.
이 기운이 흐르지 않으면 마음이 움츠러들고, 사람들과의 교류가 부담스럽고, 생각은 많지만 움직임은 줄어들게 됩니다.
겉으로 보기엔 조용하지만, 내면에선 막연한 두려움과 무력감이 일렁이고 있는 경우가 많습니다.
이럴 땐 억지로 활기를 끌어내려 하기보다, 있는 그대로의 상태를 인정해주는 시간이 먼저입니다.
차가운 기운 속에서 따뜻한 말 한마디는 깊게 스며들며, 존재를 부정하지 않고 지켜봐 주는 태도가 큰 힘이 됩니다.
누군가 이런 상태라면 “힘내”보다 “괜찮아, 천천히 와도 돼”라는 말이 훨씬 진하게 마음을 감싸줍니다.`,

  `불안은 뿌리를 알 수 없는 두려움에서 시작됩니다. 이유를 정확히 말할 수 없어 더 괴롭고, 스스로도 왜 이런지 몰라서 마음이 흔들리죠. 
이런 상태는 마치 물이 깊은 밤에 흔들리는 것처럼, 오행 중 '수(水)'의 불균형과 관련이 있습니다. 수는 생명의 근원이며 동시에 공포와 연관된 요소이기도 합니다.
이럴 땐 마음을 가라앉히는 시간이 꼭 필요합니다. 물은 억지로 멈추게 할 수 없지만, 기다리면 스스로 잔잔해지듯이요. 
혼자 있는 시간, 느린 호흡, 깊은 수면이 큰 도움이 됩니다.
상대가 불안해할 때는 논리로 설명하거나 설득하려 들기보다, 그의 감정을 허용하고 곁을 지켜주는 것이 가장 큰 위로가 됩니다. 
불안은 해결이 아니라 공감으로 다스려야 하는 감정입니다.`,

  `짜증은 막힌 에너지의 표현입니다. 하고 싶은 말은 많은데 말이 잘 안 통하고, 계획은 많은데 자꾸 어그러질 때, 마음속의 ‘목(木)’ 기운이 울컥 치솟습니다. 
목은 뻗어나가려는 힘, 자라려는 에너지인데, 그 길이 막히면 울화로 변하기 쉬운 오행입니다.
이럴 땐 움직임과 순환이 필요합니다. 산책, 스트레칭, 물 마시기 같은 가벼운 활동만으로도 목의 기운은 금방 풀릴 수 있어요. 
무엇보다 계획을 작게라도 실현시키는 행동이 가장 좋은 해소법입니다.
상대가 짜증을 낼 때는 감정을 바로잡으려 들기보다, 그가 흐를 수 있도록 여지를 주는 것이 중요합니다. 
“잠깐 바람 좀 쐬고 올까?”라는 말 한마디가 그를 다시 부드럽게 만들어 줄 수 있어요.`,

  `마음이 작아지고 위축될 때, 사람은 자신을 자꾸 깎아내리게 됩니다. 
이런 상태는 자신에 대한 단절로 이어지기 쉬우며, 오행으로 보면 ‘금(金)’ 기운이 약해진 상태입니다. 
금은 자르고 정리하는 기운이지만, 너무 약해지면 자기 판단력과 중심을 잃게 만들죠.
이럴 땐 자신을 자극하기보다 자기 존중감을 회복하는 경험이 우선입니다. 
작은 성취, 정돈된 공간, 간결한 글쓰기 같은 행위는 금의 기운을 회복시키는 데 큰 도움이 됩니다.
의기소침한 사람에게는 무리한 격려나 다그침은 오히려 해가 될 수 있어요. 
“충분히 잘하고 있어요.”, “지금 이 정도면 괜찮은 거예요.” 같은 잔잔한 지지의 말이 그를 다시 중심으로 이끌어줍니다.`,

  `분노는 가장 격렬하고 빠르게 치솟는 감정입니다. 순간적으로 이성을 잃고, 말이나 행동으로 폭발하기도 하죠. 
이는 오행 중 ‘화(火)’의 기운이 지나치게 왕성할 때 나타나는 반응입니다. 
화는 따뜻함과 열정을 뜻하지만, 균형을 잃으면 타인을 태우고 자신까지 소진시킵니다.
이럴 땐 즉각적인 진압보다 서서히 식히는 시간이 필요합니다. 깊은 호흡, 조용한 공간, 불빛 줄이기 같은 자극 완화가 효과적입니다. 
억지로 참으려 하지 말고, 감정을 조용히 흘려보낼 통로를 마련해 주세요.
상대방이 분노했을 때는 맞대응하거나 논리적으로 설득하려 하지 마세요. 
감정을 인정해 주고, 일정 거리를 두는 태도가 오히려 그 불을 꺼뜨리는 데 도움이 됩니다. 분노는 표현이 아니라 온도 조절이 필요한 감정입니다.`,

  `답답함은 움직일 수도, 터놓을 수도 없는 상태에서 시작됩니다. 
마음이 눌리고 꽉 막힌 듯한 이 감정은 ‘토(土)’의 기운이 정체되었을 때 잘 나타납니다. 
토는 중심을 잡고 받아들이는 기운이지만, 균형이 깨지면 모든 것을 혼자 떠안고 소화하지 못해 체증처럼 쌓이는 감정이 됩니다.
이럴 때는 억지로 뚫으려 하기보다, 조금씩 풀어내는 연습이 필요합니다. 
가볍게라도 이야기 나누기, 내 감정을 글로 써 보기, 속도를 늦추는 휴식이 토의 기운을 회복시키는 데 도움이 됩니다.
답답함을 느끼는 사람에게는 “별일 아니잖아” 같은 말보다, “그래서 그게 어떻게 느껴졌어요?” 같은 공감과 소화의 언어가 필요합니다. 
토의 기운은 급히 움직이지 않기에, 서두르지 않고 기다려주는 자세가 답답함을 녹이는 가장 좋은 태도입니다.`,
]
